import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=d3e46762&scoped=true&"
import script from "./privacyPolicy.vue?vue&type=script&lang=ts&setup=true&"
export * from "./privacyPolicy.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=d3e46762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e46762",
  null
  
)

export default component.exports